import { FC } from 'react';
import { useRouteMatch, Route, Switch } from 'react-router-dom';
import Main from './pages/Main';

const Dashboard: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={Main} />
    </Switch>
  );
};

export default Dashboard;
